import { Component, ViewEncapsulation } from '@angular/core';
import { Router, RouteReuseStrategy } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ToastService } from '../../../../@theme/service/toast.service';
import { CacheRouteReuseStrategy } from '../../../../cache-router-reuse-strategy';
import { Objects } from '../../../util/objects';

@Component({
  selector: 'ngx-link-column',
  template: ` <nb-icon class="mr-1" *ngIf="useFilter && params.value" style="cursor: pointer" icon="search-outline" status="primary" (click)="onClickSearch()"></nb-icon>
                <span [class.link]="useLinkColor" class="pointer" (click)="onClickLink()">{{ params.value }}</span>
               `,
  styles: [`
    .link {
      font-weight: bold !imported;
      color: #00d68f !imported;
    }
  `],
  encapsulation: ViewEncapsulation.None,
})
export class LinkColumnComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public data: any;
  public searchType: LinkType = 'file';
  public useLinkColor: boolean = false;
  public useFilter: boolean = false;
  public filterKey: string;
  public id: string;

  constructor(private router: Router,
    private routerResume: RouteReuseStrategy,
    private toast: ToastService) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = this.params.data;
    this.searchType = Objects.safeGetValue(this.params, 'searchType', null);
    this.useLinkColor = Objects.parseBoolean(Objects.safeGetValue(this.params, 'useLinkColor', 'false'));
    this.useFilter = Objects.parseBoolean(Objects.safeGetValue(this.params, 'useFilter', 'false'));
    this.filterKey = Objects.safeGetValue(this.params, 'filterKey', this.getFilterKey());
    this.id = this.params.hasOwnProperty('idPath') ? this.data[this.params['idPath']] : this.params.value;
  }

  ngOnInit() {}

  onClickSearch() {
    this.params.context.setFilter(this.filterKey, this.id);
  }

  getFilterKey(): string {
    if (this.searchType == 'instance' || this.searchType == 'instance-detail') {
      return 'instanceId'
    } else if (this.searchType == 'file' || this.searchType == 'file-detail') {
      return 'fileId'
    } else if (this.searchType == 'container' || this.searchType == 'container-detail') {
      return 'containerId'
    } else {
      throw new Error(`Invalid search type: ${this.searchType}`);
    }
  }

  onClickLink(): void {
    console.debug(this.id);

    if (this.searchType == 'file-detail' || this.searchType == 'file') {
    
    } else {
      throw new Error(`Invalid search type: ${this.searchType}`);
    }
  }
}
export declare type LinkType = 'instance' | 'instance-detail' | 'file-detail' | 'file' | 'container' | 'container-detail';




